import URI from 'jsuri';

import API from 'js/lib/api';

export const fakeWidgetRpcActions = API('/api/fakeWidgetRpcActions.v1', { type: 'rest' });

export const callAction = (name: $TSFixMe, manifest: $TSFixMe, body: $TSFixMe) => {
  const url = new URI().addQueryParam('action', name);

  return fakeWidgetRpcActions.post(url.toString(), {
    data: {
      manifest,
      body,
    },
  });
};

export const getStoredValues = (manifest: $TSFixMe, names: $TSFixMe) => {
  return callAction('getStoredValues', manifest, {
    names,
  });
};

export const setStoredValues = (manifest: $TSFixMe, values: $TSFixMe) => {
  return callAction('setStoredValues', manifest, values);
};
